var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sale-normal-info-container" },
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [_c("TitleItem", { attrs: { title: "销售信息" } })]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "125px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "套餐库存", required: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "202px" },
                    attrs: {
                      type: "number",
                      min: 0,
                      placeholder: "请输入套餐库存"
                    },
                    on: { change: _vm.changeStock },
                    model: {
                      value: _vm.currNum,
                      callback: function($$v) {
                        _vm.currNum = $$v
                      },
                      expression: "currNum"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "销售单位", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "202px" },
                      attrs: { filterable: "", placeholder: "请选择销售单位" },
                      on: { change: _vm.unitSelectChange },
                      model: {
                        value: _vm.mUnit,
                        callback: function($$v) {
                          _vm.mUnit = $$v
                        },
                        expression: "mUnit"
                      }
                    },
                    _vm._l(_vm.unitsList, function(unitItem) {
                      return _c("el-option", {
                        key: unitItem.unitsCode,
                        attrs: {
                          label: unitItem.unitsName,
                          value: unitItem.unitsCode
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }